import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import { useWsClientStatus } from 'lib/ws/ws-apollo';
import type {
  GetClassStudentsAnswersSummaryPerComponentQuery,
  GetClassStudentsAnswersSummaryPerComponentQueryVariables,
} from '../present/activity-answers.graphql.generated';
import { GET_CLASS_STUDENTS_ANSWERS_SUMMARY_PER_COMPONENT } from '../present/activity-answers.graphql';
import { ActivitiesContentType } from 'global/constants';

export const useGetStudentAnswersSummaryPollingFallback = ({
  componentId,
  userClassId,
  contentId,
  contentType,
  contentVersion,
}: {
  componentId: string;
  userClassId: number;
  contentId: number;
  contentType: ActivitiesContentType;
  contentVersion: string;
}) => {
  const { isConnectionActive } = useWsClientStatus();

  const { data, error } = useLoggingQuery<
    GetClassStudentsAnswersSummaryPerComponentQuery,
    GetClassStudentsAnswersSummaryPerComponentQueryVariables
  >(GET_CLASS_STUDENTS_ANSWERS_SUMMARY_PER_COMPONENT, {
    pollInterval: isConnectionActive ? 0 : 5000,
    variables: {
      input: {
        classId: userClassId || 1,
        componentId,
        contentId,
        contentType,
        contentVersion,
        loadDrawingData: false,
      },
    },
  });

  return {
    data,
    error,
  };
};
